import React, { useState, useEffect } from 'react';
import LeftMenu from '../components/LeftMenu';
import withAuth from '../common/auth';
import AdminSettings from '../components/AdminSettings';
import { FiSettings, FiMonitor, FiServer, FiFileText } from 'react-icons/fi';
import ReceptionDetails from '../components/ReceptionDetails';
import ApplicationSettings from '../components/ApplicationSettings';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('receptiondetails');
  const [isMenuExpanded, setIsMenuExpanded] = useState(true);
  
  const toggleMenu = () => {
    setIsMenuExpanded(!isMenuExpanded);
  };

  // Define tabs with icons for better visual appeal
  const tabs = [
    { id: 'receptiondetails', label: 'Reception Settings', icon: <FiFileText /> },
    { id: 'application', label: 'Application Settings', icon: <FiMonitor /> },
    { id: 'admin', label: 'Admin Settings', icon: <FiServer /> }
  ];
  
  return (
    <div className="flex h-full bg-background">
      
      <div className="p-6 flex-1 flex flex-col overflow-hidden">
        {/* Page Header */}
        <div className="bg-white rounded-xl shadow-sm p-3 mb-3">
          <div className="flex items-center">
            <h1 className="text-lg font-bold text-gray-800">Application Settings</h1>
          </div>
        </div>
        
        {/* Tabs Navigation */}
        <div className="bg-white rounded-xl shadow-sm p-1 mb-6">
          <div className="flex">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center justify-center px-6 py-3 text-sm font-medium rounded-lg transition-all duration-200 flex-1 ${
                  activeTab === tab.id 
                    ? 'bg-indigo-50 text-indigo-600' 
                    : 'text-gray-500 hover:bg-gray-50'
                }`}
              >
                <span className={`mr-2 ${activeTab === tab.id ? 'text-indigo-600' : 'text-gray-400'}`}>
                  {tab.icon}
                </span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        
        {/* Content Area */}
        <div className="flex-1 overflow-hidden rounded-xl bg-white shadow-sm">
          <div className="h-full overflow-auto">
            {activeTab === 'receptiondetails' && <ReceptionDetails />}
            {activeTab === 'application' && <ApplicationSettings />}
            {activeTab === 'admin' && <AdminSettings />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAuth(Settings);